import { isEmpty } from 'lodash'
import React, { FunctionComponent, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { OnDemandGallery } from '../../components/OnDemandGallery'
import logo from '../../images/backdrops/gallery_logo.png'
import Amplitude from '../../utils/amplitudeHelper'
import { PageStyle } from './styled'

interface DesktopOnDemandTypes {
  currentUser: {
    id: string
    role: string
    email: string
    [key: string]: any
  }
}

const DesktopOnDemand: FunctionComponent<DesktopOnDemandTypes> = ({ currentUser }) => {
  const history = useHistory()
  const { pageTitle, previousPagePath } = useSelector((state) => state.onDemand)

  useEffect(() => {
    Amplitude.visit(pageTitle)
  }, [currentUser.id, pageTitle])

  const goBack = () => {
    if (isEmpty(previousPagePath) || previousPagePath === undefined) {
      history.goBack()
    } else {
      history.push(previousPagePath)
    }
  }

  return (
    <PageStyle>
      <section className="page-layout">
        <div className="sidenavs">
          <img src={logo} className="d-block mx-auto mt-5 mb-3" width="90%" alt="logo" />
        </div>
        <div className="page-content">
          <header onClick={goBack} className="back-btn">
            <div className="back-icon">
              <svg width="17.301" height="26.839" viewBox="0 0 17.301 26.839">
                <g transform="translate(17.301 26.839) rotate(180)">
                  <path
                    d="M.459,14.462,13.147,26.407a1.637,1.637,0,0,0,2.216,0l1.48-1.393a1.415,1.415,0,0,0,0-2.084L6.79,13.419,16.845,3.909a1.415,1.415,0,0,0,0-2.084L15.363.432a1.637,1.637,0,0,0-2.216,0L.459,12.376A1.415,1.415,0,0,0,.459,14.462Z"
                    transform="translate(17.301 26.839) rotate(180)"
                    fill="#000"
                  />
                </g>
              </svg>
              <small className="icon-label">Back</small>
            </div>
            <span>{pageTitle}</span>
          </header>

          <OnDemandGallery />
        </div>
      </section>
    </PageStyle>
  )
}

export default DesktopOnDemand
